import * as React from "react";
import { Button, Typography } from "@material-ui/core";

import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";

import PropalIcon from "../Icons/PropalIcon";
import { styles } from "./Cover.style";
import { ProductName } from "../../types/Products";

type CoverType = {
    image: string,
    title: string,
    target: string,
    topic: string
};
interface CoverProps {
    data: CoverType;
    name: ProductName;
    variant?: string;
    push?(path: string);
}

interface CoverState {
    background: any;
}

class Cover extends React.Component<CoverProps & WithStyles<typeof styles>, CoverState> {

    state: CoverState = {
        background: null
    };

    async componentDidMount() {
        await this.addBackground(`${this.props.data.image}.jpg`);
    }

    async componentWillReceiveProps(newProps: CoverProps) {
        await this.addBackground(`${newProps.data.image}.jpg`);
    }

    public render() {

        const { classes, theme, data } = this.props;
        const { background } = this.state;

        const link = `${this.props.name}${this.props.variant ? "/" + this.props.variant : ""}`;

        return (
            <div className={classes.container} style={{backgroundImage: `url(${background})`}}>
                <div className={classes.content}>
                    <Typography variant="display1" color="inherit" component="h1" className={classes.title}>{data.title}</Typography>

                    <div className={classes.details}>
                        <Typography variant="subheading" color="inherit">Cible :</Typography>
                        <Typography variant="body1" color="inherit" dangerouslySetInnerHTML={{ __html: data.target }} />
                        <Typography variant="subheading" color="inherit">Objet :</Typography>
                        <Typography variant="body1" color="inherit">{data.topic}</Typography>
                    </div>
                </div>
                <Button className={classes.button} onClick={() => this.props.push(`/quotation/${link}`)}>
                    <PropalIcon nativeColor={theme.palette.primary.contrastText}/>
                    <span className={classes.buttonLabel}>Créer une proposition</span>
                </Button>
            </div>
        );
    }

    addBackground = async path => {
        import(`./assets/${path}`)
            .then(image =>
                this.setState({
                    background: image
                })
            )
            .catch(error => {
                window.console.error(`"${path}" not found`);
            });
    }

}

export default withStyles(styles, { withTheme: true })(Cover);


// WEBPACK FOOTER //
// ./src/components/Cover/Cover.tsx